<style lang="less" scoped>
.page-reality-index {
    background: #000 url("../../../assets/img/reality/bg_base.jpg") 50% 0 no-repeat;
    background-size: 100% auto;
    min-height: 100vh;
}
</style>

<template>
  <div class="page page-reality-index">
    <index-main />
    <index-rule />
  </div>
</template>

<script>
  import Main from './index-main'
  import Rule from './index-rule'
  export default {
    components : {
      [Main.name] : Main,
      [Rule.name] : Rule
    }
  };
</script>
